import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function virtualGameCardsRouteI18n(): string {
  return (appRoutesI18nCache['virtual-game-cards'] ??=
    $localize`:url-segment@@virtual-game-cards-url-segment:virtual-game-cards`);
}
